import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VendorSelectValues } from '../packages-module/models/searchPackage';

@Injectable({
  providedIn: 'root'
})
export class ProcessorReportsService {

  constructor(private http: HttpClient) { }

  // I want this to be generic but we need to mock a POST sample for report with params. hit me up if yo uare working on this so I can help... db
  getReportData(rpt:ProcessorReport): Observable<any>{
    return this.http.post(environment.baseURl +'/api/reportdownload/rpt',rpt, { responseType: 'blob' });
  }

  getReportsList(): Observable<ProcessorReport[]>{
    return this.http.get<ProcessorReport[]>(environment.baseURl +'/api/reportdownload/rpt/list');
  }

  searchVendors : VendorSelectValues[] = [
    { vendorName: 'TazWorks' , vendorId : 0},
    { vendorName: 'Tracers' , vendorId : 1},
    { vendorName: 'Custom' , vendorId : 2},
    { vendorName: 'UtahCourts' , vendorId : 3},
    { vendorName: 'SJV' , vendorId : 4},
    { vendorName: 'Cleara' , vendorId : 5},
    { vendorName: 'Wholesale' , vendorId : 6},
    { vendorName: 'MasterCard' , vendorId : 7},
    { vendorName: 'Equifax' , vendorId : 8},
    { vendorName: 'Finicity' , vendorId : 9}
  ]

}

export interface ProcessorReport {
    id: number;
    reportPrettyName: string;
    reportDownloadName : string;
    reportSproc: string;
    hasParams : boolean;
    params: any[];
    dialogName : string;
    dialog : any;
}

